import { render, staticRenderFns } from "./LayoutAdmin.vue?vue&type=template&id=bfbc10a8&scoped=true"
import script from "./LayoutAdmin.vue?vue&type=script&lang=ts"
export * from "./LayoutAdmin.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfbc10a8",
  null
  
)

export default component.exports